<template>
    <div class="platformmerchantlist">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button> 
            <el-date-picker v-model="daterange" size="medium" type="daterange" range-separator="-" start-placeholder="开始日期" @change="queryBillFlowListfun()" end-placeholder="结束日期" :clearable="false"  ></el-date-picker>
            <el-select class="selectWidth" size="medium" style="width:120px" v-model="pagination.subMerId" @change="queryBillFlowListfun()" >
                <el-option :label='item.subMerName' v-for="(item,index) in merIdlist" :key="index" :value="item.subMerId"> </el-option>
            </el-select> 
            <span>清分金额：{{withdtotal||"0"}}</span>
            <el-input class="search-input" style="width:20%;float: right;"  placeholder="请输入学校名称" icon="search" size="medium" @change="queryBillFlowListfun()"
                          v-model.trim="pagination.schoolName">
                    <el-button slot="append" icon="el-icon-search" @click="queryBillFlowListfun()"></el-button>
            </el-input>
        </div>
        <el-table stripe :data="dataList" border fit highlight-current-row  :height="maxH-30">            			
                <el-table-column align="center" label="批次名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span >{{scope.row.withdName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="缴费类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span >{{scope.row.typeName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="清分日期" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span >{{scope.row.withdDate}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="清分账户" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span >{{scope.row.subMerName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="清分金额" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span >{{scope.row.totalfee}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="学校名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span >{{scope.row.schoolName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="清分人" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span >{{scope.row.withduname}}</span>
                    </template>
                </el-table-column>
                 <el-table-column align="center" label="交易状态">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark"  v-if="scope.row.status==4" :content="scope.row.reason" placement="top">
                            <el-tag type="danger"  size="mini">出金失败</el-tag>
                        </el-tooltip>                 
                        <el-tag type="success" size="mini" v-if="scope.row.status==3">已出金</el-tag>
                        <el-tag type="warning" size="mini" v-if="scope.row.status==1">申请中</el-tag>
                        <el-tag type="warning" size="mini" v-if="scope.row.status==2">处理中</el-tag>
                        <el-tag size="mini" v-if="scope.row.status==5">已撤回</el-tag>
                        <el-tag size="mini" v-if="scope.row.status==6">受理成功</el-tag>
                        <el-tag type="warning" size="mini" v-if="scope.row.status==7">受理成功未出金</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" v-if="scope.row.status==3" @click="downloadReceipt(scope.row.withdBatchSn)">电子回单下载</el-button>
            <el-button type="text" size="small" v-if="scope.row.status==6" @click="queryWithdProgress(scope.row.withdBatchSn)">查询出金进度</el-button>
            <el-button type="text" size="small" v-if="scope.row.status==7" @click="updateWithdRetry(scope.row.withdBatchSn)">重新申请</el-button>
					</template>
				</el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="queryBillFlowListfun" @current-change="queryBillFlowListfun"
                               :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 50]"
                               :page-size.sync="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                               :total="pagination.total">
                </el-pagination>
            </div>
    </div>
</template>
<script>
import moment from "moment";
import { querySubmerhPurseByMerId,queryWithdBatchList,downloadReceipt,queryWithdProgress,updateWithdRetry} from "@/api/platformmerchant";
import baseMixin from "@/mixins/baseMixin";
import mixin from "@/mixins/windowResize";
export default {
  name: "statisticsIndex",
  data() {
    return {
      daterange: [new Date(), new Date()],
      dataList: [],
      pagination: {
        pageNo: 1,
        pageSize: 20,
        total: null,
        schoolName: "",
        withdDateStart: "",
        withdDateEnd: "",
        merId: this.$route.query.merId,
        subMerId: ""
      },
      merIdlist:[],
      withdtotal:""
    };
  },
  mixins: [baseMixin, mixin],
  created() {
    this.daterange[0] = new Date(moment().set("date", 1).valueOf());
     querySubmerhPurseByMerId(this.$route.query.merId)
        .then(res => {
          if (res.data.code === 200) {
           this.merIdlist=res.data.data;
           this.pagination.subMerId=this.merIdlist[0].subMerId;
           this.withdtotal=this.merIdlist[0].withdtotal;
           this.queryBillFlowListfun();
          }
        }).catch();
    
  },
  methods: {
    queryWithdProgress(id) {
			this.$confirm('是否查询出金进度?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					queryWithdProgress(id).then(res => {
						this.queryBillFlowListfun()
						this.$message({
							type: 'success',
							message: '查询出金进度成功!'
						})
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消查询出金进度查询'
					})
				})
		},
    updateWithdRetry(id) {
			this.$confirm('是否出金重新申请?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					updateWithdRetry(id).then(res => {
						this.queryBillFlowListfun()
						this.$message({
							type: 'success',
							message: '出金重新申请成功!'
						})
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消出金重新申请'
					})
				})
		},
    downloadReceipt(withdBatchSn){
       let myhref=(global.command === "production"?"https://pay.zhxiaoyuan.cn":"https://pay.weixiaojia.net")+"/orderpay/withd/downloadReceipt?withdBatchSn="+withdBatchSn+"&token="+this.$store.getters.token
        window.open(myhref,"_blank");
   },
    queryBillFlowListfun() {
        for(let i=0;i<this.merIdlist.length;i++){
            if(this.pagination.subMerId==this.merIdlist[i].subMerId){
                this.withdtotal=this.merIdlist[i].withdtotal;
            }
        }
      this.pagination.withdDateStart = moment(this.daterange[0]).format(
        "YYYY-MM-DD"
      );
      this.pagination.withdDateEnd = moment(this.daterange[1]).format(
        "YYYY-MM-DD"
      );
      queryWithdBatchList(this.pagination)
        .then(res => res.data)
        .then(data => {
          this.pagination.total = data.data.pagination.total;
          this.dataList = data.data.dataList;
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.platformmerchantlist {
  padding:12px;
  .top {
    padding-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/platformmerchant/platformmerchantlist.vue